import "./policyContainer.css";

const PolicyContainer = ({ text }) => {
  return (
    <div className="policy-container">
      <div>
        By clicking "{text}" <br />
        you agree to our{" "}
        <a href="/assets/content/DataProtectionPolicy.pdf" target="_blank">
          Data Protection Policy
        </a>
      </div>
    </div>
  );
};

export default PolicyContainer;
